import { render } from "./SectionPaymentTransaction.vue?vue&type=template&id=43696d7b"
import script from "./SectionPaymentTransaction.vue?vue&type=script&lang=js"
export * from "./SectionPaymentTransaction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__